import actionTypes from '@types/basic/layout'

export const setMenuData = payload => ({
  type: actionTypes.SET_MENU_DATA,
  payload: payload
})

export const setOpenKeys = payload => ({
  type: actionTypes.SET_OPEN_KEYS,
  payload: payload
})

export const setSelectedKeys = payload => ({
  type: actionTypes.SET_SELECTED_KEYS,
  payload: payload
})

export const toggle = () => ({
  type: actionTypes.TOGGLE
})
export const setLayout = payload => ({
  type: actionTypes.SET_LAYOUT,
  payload: payload
})
export const updateTabsList = payload => ({
  type: actionTypes.UPDATE_TAB_LIST,
  payload: payload
})

export const delTabsItem = payload => ({
  type: actionTypes.DELETE_TAB_ITEM,
  payload: payload
})

export const setSearchObj = payload => ({
  type: actionTypes.SET_SEARCH_OBJ,
  payload: payload
})
